import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSnackBar } from '@angular/material/snack-bar';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuthService, authBaseInterceptor } from '@t-llevo/auth';
import { FilesService, NotificationService } from '@t-llevo/common-ui';
import { Environment } from '@t-llevo/util';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimationsAsync(),
    { provide: Environment, useValue: environment },
    provideHttpClient(withInterceptors([authBaseInterceptor])),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    MatSnackBar,
    AuthService,
    FilesService,
    NotificationService,
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [NgxPermissionsService],
    },
  ],
};

export function initializeApp(/*permissionService: NgxPermissionsService*/) {
  return async () =>
    new Promise((resolve) => {
      if (localStorage.getItem('sessionData')) {
        const localStorageTmp = String(localStorage.getItem('sessionData'));
        if (localStorageTmp) {
          /*const sessionData: AuthBasicData<User> = JSON.parse(localStorageTmp);
          const permission = jwtDecode<User>(
            sessionData.access
          ).user_permissions;
          permissionService.addPermission(permission);
          permissionService.loadPermissions(permission);*/
        }
      }
      resolve(true);
    });
}
